<template>
  <div class="pipe-page">

    <!-- ═══ 顶部操作栏 ═══ -->
    <section class="module-topbar">
      <button class="btn-download" @click="$emit('download')">
        <svg viewBox="0 0 20 20" fill="currentColor" style="width:16px;height:16px">
          <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
        下载客户端
      </button>
    </section>

    <!-- ═══ 功能特性 ═══ -->
    <section class="pipe-intro">
      <div class="pipe-intro-features">
        <div class="pipe-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          <span>Aspen Plus 工艺数据</span>
        </div>
        <div class="pipe-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4"/>
          </svg>
          <span>管径 · 壁厚 · 压降计算</span>
        </div>
        <div class="pipe-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          <span>流速优化分析</span>
        </div>
        <div class="pipe-feat">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:20px;height:20px">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
          <span>Word 选型报告输出</span>
        </div>
      </div>
    </section>

    <!-- ═══ PDF 预览区 ═══ -->
    <section class="pipe-pdf-section">
      <div class="pipe-pdf-head">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:16px;height:16px">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
        </svg>
        报告预览
        <span class="pipe-pdf-hint">缩放 · 打印 · 下载 · 搜索</span>
      </div>
      <div class="pipe-pdf-wrap">
        <vue-pdf-app
          v-if="pdfSrc"
          :pdf="pdfSrc"
          theme="dark"
          :page-scale="'page-fit'"
          class="pipe-pdf-viewer"
        />
        <div v-else class="pipe-pdf-empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="width:56px;height:56px;opacity:.15">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          <p class="pipe-pdf-empty-text">暂无报告</p>
          <p class="pipe-pdf-empty-sub">请先进行管道选型操作</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import VuePdfApp from 'vue3-pdf-app'
import 'vue3-pdf-app/dist/icons/main.css'

defineEmits(['download'])

const pdfSrc = ref('/pdfs/管道选型_20260424_210004_ALL.pdf')
</script>

<style scoped>
/* ═══ Page ═══ */
.pipe-page {
  display: flex;
  flex-direction: column;
  padding: 0 0 40px;
}

/* ═══ 顶部操作栏 ═══ */
.module-topbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 40px;
  border-bottom: 1px solid #e8eaed;
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
}

.btn-download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: 8px;
  background: #4285f4;
  color: #fff;
  font-size: 13.5px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  animation: heartbeat 2.5s ease-in-out infinite;
}

.btn-download:hover {
  background: #3367d6;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(66,133,244,.3);
}

.btn-download:active {
  transform: translateY(0);
}

@keyframes heartbeat {
  0%, 100% { box-shadow: 0 0 0 0 rgba(66,133,244,.45); }
  50%       { box-shadow: 0 0 0 10px rgba(66,133,244,0); }
}

/* ═══ 功能特性 ═══ */
.pipe-intro {
  padding: 28px 40px;
  border-bottom: 1px solid #e8eaed;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}
.pipe-intro-features {
  display: flex; flex-wrap: wrap; gap: 10px;
}
.pipe-feat {
  display: flex; align-items: center; gap: 7px;
  padding: 7px 14px; background: #fff;
  border: 1px solid #dadce0; border-radius: 8px;
  font-size: 13px; font-weight: 600; color: #5f6368;
  transition: border-color .15s, box-shadow .15s;
}
.pipe-feat:hover { border-color: #4285f4; box-shadow: 0 2px 8px rgba(66,133,244,.1); }
.pipe-feat svg { color: #4285f4; flex-shrink: 0; }

/* ═══ PDF 预览 ═══ */
.pipe-pdf-section {
  padding: 20px 40px 0;
}
.pipe-pdf-head {
  display: flex; align-items: center; gap: 8px;
  font-size: 13px; font-weight: 700; color: #202124;
  margin-bottom: 10px;
}
.pipe-pdf-head svg { color: #4285f4; }
.pipe-pdf-hint {
  margin-left: auto; font-size: 11px; font-weight: 500;
  color: #9aa0a6; background: #f1f3f4;
  padding: 2px 10px; border-radius: 6px;
}
.pipe-pdf-wrap {
  border: 1px solid #dadce0; border-radius: 12px;
  overflow: hidden;
  height: calc(100vh - 320px);
  min-height: 600px;
  position: relative;
}
.pipe-pdf-viewer {
  width: 100%;
  height: 100%;
}
.pipe-pdf-empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  height: 100%; gap: 8px; background: #f8f9fa;
}
.pipe-pdf-empty-text {
  font-size: 15px; font-weight: 700; color: #bdc1c6; margin: 0;
}
.pipe-pdf-empty-sub {
  font-size: 12px; color: #dadce0; margin: 0;
}

/* ═══ Responsive ═══ */
@media (max-width: 768px) {
  .pipe-intro { padding: 20px 16px; }
  .pipe-intro-features { gap: 6px; }
  .pipe-feat { font-size: 12px; padding: 6px 10px; }
  .pipe-pdf-section { padding: 16px 16px 0; }
  .pipe-pdf-wrap { height: 500px; min-height: 500px; }
}
</style>
